import React, { useContext } from 'react'
import { FaGripHorizontal, FaInfoCircle, FaSave, FaSyncAlt, FaTimes } from 'react-icons/fa'
import { CurrentDashboardContext } from '../wrappers/CurrentDashboardContext'
import { Link } from 'react-router-dom'
import InfoButton from './landing-page/InfoButton'

const LayoutEditorToggle = () => {
    const {
        dashboardName,
        editingLayout,
        saveLayoutState,
        startLayoutEdit,
        cancelLayoutEdit,
        resetLayoutState
    } = useContext(CurrentDashboardContext)

    return (
        <>
            <InfoButton 
                dashboardName={dashboardName}
                className={'topBarInfoButtonWrapper'}
            />
            <div className="topBarEditComponentWrapper ">
                <div
                    className="topBarEditToggle toggle"
                    // data-tooltip-content={`${editingLayout ? 'Save Layout' : 'Edit Layout'}`}
                    // data-tooltip-id={'editLayout'}
                    onClick={() => {
                        editingLayout ? saveLayoutState() : startLayoutEdit()
                    }}
                >
                    {editingLayout ? <FaSave /> : <FaGripHorizontal />}
                    <div className="toggle">
                        {`${editingLayout ? 'Save' : 'Edit'} Layout`}
                    </div>
                    {/* <Tooltip id={'editLayout'} /> */}
                </div>
                {editingLayout && (
                    <>
                        <div
                            className="topBarEditToggle toggle resetToggle"
                            // data-tooltip-content={`Reset Layout State`}
                            // data-tooltip-id={'resetLayout'}
                            onClick={() => {
                                resetLayoutState()
                            }}
                        >
                            <FaSyncAlt />
                            <div className="toggle">
                                {`Reset Layout`}
                            </div>
                            {/* <Tooltip id={'resetLayout'} /> */}
                        </div>
                        <div
                            className="topBarEditToggle toggle"
                            // data-tooltip-content={`Cancel`}
                            // data-tooltip-id={'cancelEdit'}
                            onClick={() => {
                                cancelLayoutEdit()
                            }}
                        >
                            <FaTimes />
                            <div className="toggle">
                                {`Cancel`}
                            </div>
                            {/* <Tooltip id={'cancelEdit'} /> */}
                        </div>
                    </>
                )}
            </div>
        </>
    )
}

export default LayoutEditorToggle